/* eslint-disable react/no-unstable-nested-components */
import { Authenticator, ThemeProvider } from '@aws-amplify/ui-react';
// eslint-disable-next-line import/no-unresolved
import '@aws-amplify/ui-react/styles.css';
import { Box } from '@mui/material';
import { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import App from '../App';
import AppCrashFallback from './AppCrashFallback';
import HeaderContainer from '../App/Components/Header/styles';
import AmplifyContextProvider from '../App/Contexts/AmplifyContext/AmplifyContextProvider';
import { useIsFromApp } from '../App/Hooks/useIsInIframe';
import useLanguageUpdate from '../App/Hooks/useLanguageUpdate';
import { CookieProvider } from '../App/Hooks/useUserInfo';
import { syncAmplifyLanguage } from './amplifyI18n';
import DualChannelAppAuthenticator from './DualChannelAppAuthenticator';
import SignInHeader from './Headers/SignInHeader';
import logoSrc from './logo.svg';
import SignIn from './SignIn';
import StyledBox from './styles';
import theme from './theme';

export default function AuthenticatedApp() {
  useLanguageUpdate();
  const { i18n } = useTranslation();
  const isFromApp = useIsFromApp();

  useEffect(() => {
    syncAmplifyLanguage(i18n.resolvedLanguage || i18n.language);
  }, [i18n.language, i18n.resolvedLanguage]);

  if (isFromApp) {
    return (
      <StyledBox>
        <ThemeProvider theme={theme}>
          <DualChannelAppAuthenticator />
        </ThemeProvider>
      </StyledBox>
    );
  }

  return (
    <StyledBox>
      <ThemeProvider theme={theme}>
        <Authenticator
          hideSignUp
          components={{
            Header() {
              return (
                <HeaderContainer id="login-header">
                  <Box>
                    <img src={logoSrc} alt="logo" />
                  </Box>
                  <div />
                </HeaderContainer>
              );
            },
            SignIn: {
              Header: SignInHeader,
              Footer: SignIn,
            },
          }}
          loginMechanisms={['email']}
        >
          {({ signOut, user }) => (
            <ErrorBoundary
              FallbackComponent={AppCrashFallback}
              onError={(error) => console.error('[AuthenticatedApp] App-level crash', error)}
            >
              <CookieProvider>
                <AmplifyContextProvider signOut={signOut} user={user}>
                  <App />
                </AmplifyContextProvider>
              </CookieProvider>
            </ErrorBoundary>
          )}
        </Authenticator>
      </ThemeProvider>
    </StyledBox>
  );
}
